import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpService } from '../http/http.service';

@Injectable()
export class TiposPlataformaService extends ApiService {
    url = 'api/tipos-plataforma/';
}
